import { glovoMedia } from '@glovo/multimedia'
import { logger } from '../o11y/server'
import { getProviders } from './providers/providers'
import type { GetImageParams } from './types'

let isInitialized = false

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onImageServiceError = async (error: Error, errorContext: any): Promise<void> => {
  logger.error(error.name || 'cw-image-service', error.message, errorContext)
}

export const getImageUrl = ({ source, options }: GetImageParams): string => {
  if (!isInitialized) {
    glovoMedia.init({ providers: getProviders(), onError: onImageServiceError })
    isInitialized = true
  }

  return glovoMedia.getImageUrl(source, options)
}
